<template>
<!--    <div>-->
<!--        <div class="booking-flyier m-t-50"-->
<!--             :class="route_name === 'Step2' ? 'hidden-xs': ''">-->
<!--            <div class="div">-->
<!--                <label for="location-mobile" class="text-muted visible-xs">LOCATION</label>-->
<!--                <div class="form-group has-feedback select_box_dropdown" data-toggle="modal" data-target="#location-modal">-->
<!--                    <input type="text"-->
<!--                           readonly-->
<!--                           autocomplete="off"-->
<!--                           name=""-->
<!--                           :value="getResortName"-->
<!--                           placeholder="Location"-->
<!--                           id="location"-->
<!--                           class="form-control hidden-xs"-->
<!--                           :style="'font-size:'+(getResortName && getResortName.length>25 ? 14: 20) + 'px'"-->
<!--                           required>-->

<!--                    <input type="text"-->
<!--                           readonly-->
<!--                           autocomplete="off"-->
<!--                           name=""-->
<!--                           :value="getResortName"-->
<!--                           placeholder="Location"-->
<!--                           id="location-mobile"-->
<!--                           class="form-control visible-xs"-->
<!--                           :style="'font-size:'+(getResortName && getResortName.length>25 ? 14: 16) + 'px'"-->
<!--                           required>-->
<!--                    &lt;!&ndash;                    <span class="fa fa-caret-down fa-maring-top form-control-feedback"></span>&ndash;&gt;-->
<!--                    <img :src="base_url+'/cart-booking/static/assets/images/dropdown-arrow.png'" alt="">-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="div">-->
<!--                <label for="delivery-date" class="text-muted visible-xs">DELIVERY DATE</label>-->
<!--                <div class="form-group has-feedback select_box_dropdown">-->
<!--                    <input type="text"-->
<!--                           v-if="form.resort_id"-->
<!--                           :placeholder="form.is_pickup == 1 ? 'Fitting Date': 'Delivery Date'"-->
<!--                           id="delivery-date"-->
<!--                           class="form-control"-->
<!--                           :value="delivery_date_time"-->
<!--                           data-toggle="modal"-->
<!--                           data-target="#delivery-date-modal" readonly required>-->
<!--                    <input type="text"-->
<!--                           v-else-->
<!--                           name=""-->
<!--                           :placeholder="form.is_pickup == 1 ? 'Fitting Date': 'Delivery Date'"-->
<!--                           class="form-control"-->
<!--                           :value="delivery_date_time"-->
<!--                           readonly required>-->
<!--                    <span class="fa fa-calendar form-control-feedback"></span>-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="div">-->
<!--                <label for="return-date" class="text-muted visible-xs">RETURN DATE</label>-->
<!--                <div class="form-group has-feedback select_box_dropdown">-->
<!--                    <input type="text"-->
<!--                           v-if="form.resort_id && form.delivery_date && form.delivery_time"-->
<!--                           placeholder="Return Date"-->
<!--                           id="return-date"-->
<!--                           class="form-control"-->
<!--                           :value="form.return_date"-->
<!--                           data-toggle="modal"-->
<!--                           data-target="#return-date-modal" readonly required>-->
<!--                    <input type="text"-->
<!--                           v-else-->
<!--                           placeholder="Return Date"-->
<!--                           class="form-control"-->
<!--                           :value="form.return_date"-->
<!--                           readonly required>-->
<!--                    <span class="fa fa-calendar  form-control-feedback"></span>-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="div">-->
<!--                <a href="Javascript:void(0);" class="btn btn-blue" @click="saveStep1" v-if="step1_completed">-->
<!--                    <span class="visible-xs">SEARCH</span>-->
<!--                    <span class="hidden-xs">-->
<!--                         <svg xmlns="http://www.w3.org/2000/svg" width="19.439" height="19.445"-->
<!--                              viewBox="0 0 19.439 19.445">-->
<!--                        <g id="search" transform="translate(0 0)">-->
<!--                            <path id="circle2017"-->
<!--                                  d="M9.232,291.161a8.722,8.722,0,1,0,5.431,15.531l3.631,3.63a.971.971,0,0,0,1.374-1.372l-3.632-3.631a8.708,8.708,0,0,0-6.805-14.157Zm0,1.938a6.784,6.784,0,1,1-6.78,6.78,6.764,6.764,0,0,1,6.78-6.78Z"-->
<!--                                  transform="translate(-0.514 -291.161)" fill="#fff"/>-->
<!--                        </g>-->
<!--                    </svg>-->
<!--                    </span>-->

<!--                </a>-->
<!--                <a href="Javascript:void(0);" class="btn btn-blue" v-else>-->
<!--                    <span class="visible-xs">SEARCH</span>-->
<!--                    <span class="hidden-xs">-->
<!--                          <svg xmlns="http://www.w3.org/2000/svg" width="19.439" height="19.445"-->
<!--                               viewBox="0 0 19.439 19.445">-->
<!--                        <g id="search" transform="translate(0 0)">-->
<!--                            <path id="circle2017"-->
<!--                                  d="M9.232,291.161a8.722,8.722,0,1,0,5.431,15.531l3.631,3.63a.971.971,0,0,0,1.374-1.372l-3.632-3.631a8.708,8.708,0,0,0-6.805-14.157Zm0,1.938a6.784,6.784,0,1,1-6.78,6.78,6.764,6.764,0,0,1,6.78-6.78Z"-->
<!--                                  transform="translate(-0.514 -291.161)" fill="#fff"/>-->
<!--                        </g>-->
<!--                    </svg>-->
<!--                    </span>-->

<!--                </a>-->

<!--            </div>-->
<!--        </div>-->
<!--        <div class="short-delivery-detail" :class="route_name === 'Step2' ? 'visible-xs': 'hidden'">-->
<!--            <short-delivery-detail :editing_allowed="true"/>-->
<!--        </div>-->

<!--        &lt;!&ndash;    Modals&ndash;&gt;-->
<!--        <location-modal/>-->
<!--        <delivery-date-modal/>-->
<!--        <return-date-modal :from-wp="fromWp" :from-detail-bar="false"/>-->
<!--    </div>-->

    <div class="row">
        <div class="col-md-9 col-md-offset-1-5" :class="route_name === 'Step2' ? 'hidden-xs': ''">
            <div class="card booking-flayer" id="booking-flayer">
                <div class="card-body">
                    <div class="row vertical-centered">
                        <div class="col-md-3 vertical-divider">
                            <div class="dropdown">
                                <p class="text-center dropdown-toggle bs3-dropdown-toggle" id="location-drop-down" data-toggle="dropdown">
                                    <span class="pull-left">
                                        <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 384 512"><!-- SVG Content --></svg>
                                    </span>
                                    <span class="pull-right" v-if="portal && portal.disable_location"></span>
                                    <span class="pull-right" v-else><i class="fa fa-angle-down"></i></span>
                                    <span v-if="getResortName" style="white-space: normal">{{ getResortName }}</span>
                                    <span v-else style="white-space: normal">{{ trans('step1.select_location','Select location') }}</span>
                                </p>

                                <ul v-if="portal && portal.disable_location"></ul>
                                <ul class="dropdown-menu bs3-drp-menu dropdown-location" v-else :class="[dropdownUp ? 'dropdown-menu-top' : '']">
                                    <li>
                                        <p class="m-b-15">{{ trans('step1.choose_your_location','Choose your location') }}
                                            <span class="pull-right" @click="closeDropdown()">
                                                <i class="fa fa-times" @click="closeDropdown()"></i>
                                            </span>
                                        </p>
                                    </li>
                                    <li
                                        :class="[resort.id === form.resort_id ? 'active' : '']"
                                        @click="changeResort(resort.id)"
                                        v-for="resort in resorts"
                                        :key="resort.id">
                                        <a href="Javascript:void(0)">{{ resort.name }}</a>
                                    </li>
                                    <li v-if="!form.resort_id && location_data_submitted">
                                        <span class="text-danger m-t-0 p-l-10">{{trans('step1.plz_select_resort','Please Select Your Location.')}}</span>
                                    </li>
                                    <template v-if="resort_id && stores.length > 0">
                                        <li class="divider"></li>
                                        <li>
                                            <div class="row check_box_model">
                                                <div class="col-xs-6"  v-if="getResortCode !== 'OSP'">
                                                    <div class="form-group">
                                                        <input id="del-option" @change="updateFocus" v-model="is_pickup" type="radio" class="radio radio-inline" name="is_pickup" value="0">
                                                        <label for="del-option">{{ trans('general.delivery','Delivery') }}</label>
                                                    </div>
                                                </div>
                                                <div class="col-xs-6">
                                                    <div class="form-group">
                                                        <input id="pick-option" @change="updateFocus" v-model="is_pickup" type="radio" class="radio radio-inline" name="is_pickup" value="1">
                                                        <label for="pick-option" v-if="getResortCode !== 'OSP'">{{ trans('general.pickup','Pickup') }}</label>
                                                        <label for="pick-option" v-else>Private Ski Valet</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                        <li v-if="is_pickup == 1">
                                            <div class="form-group select_box_dropdown">
                                                <select v-model="store_id" name="store_id" id="store_id"
                                                        class="form-control select_box_input"
                                                        data-style="btn-primary" required="required">
                                                    <option :value="null" disabled>{{trans('step1.store_location','Store Location')}}</option>
                                                    <option :value="store.id" v-for="store in stores" :key="store.id">
                                                        {{ store.name }}
                                                    </option>
                                                </select>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="row">
                                                <div class="col-md-12 text-center" ref="resortButtonWrapper">
                                                    <button @click="saveLocationData()" type="button" id="resort-next" style="margin-top: 2px;"
                                                            class="btn btn-primary select-button">{{ trans('step1.select_btn', 'Select') }}
                                                    </button>
                                                </div>
                                            </div>
                                        </li>
                                    </template>
                                    <li v-if="isLoading">
                                        <div class="overlay-loader">
                                            <i class="overlay-img-load"></i>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div class="horizontal-divider"></div>
                        </div>
                        <div class="col-md-3 vertical-divider" :class="delivery_date_time ? 'p-l-m-0 p-r-m-0' :''">
                            <div class="dropdown">
                                 <p class="text-center dropdown-toggle bs3-dropdown-toggle" id="delivery-drop-down" data-toggle="dropdown">
                                    <span class="pull-left">
                                        <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512"><!--! Font Awesome Free 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H64C28.7 64 0 92.7 0 128v16 48V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 144 128c0-35.3-28.7-64-64-64H344V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H152V24zM48 192H400V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192z"/></svg>
                                    </span>
                                     <span class="pull-right"><i class="fa fa-angle-down"></i></span>
                                     <span v-if="delivery_date_time" style="white-space: normal">{{ delivery_date_time }}</span>
                                    <span v-else style="white-space: normal">{{ form.is_pickup == 1 ? trans('step1.pickup_date','Fitting Date'): trans('step1.delivery_date','Delivery Date') }}</span>
                                 </p>
                                <ul v-if="form.resort_id" class="dropdown-menu bs3-drp-menu dropdown-delivery dropdown-calendar" :class="[dropdownUp? 'dropdown-menu-top' : '']">
                                    <li>
                                            <p class='m-b-15'>{{ form.is_pickup == 1 ?trans('step1.choose_your_fitting_date','Choose your fitting date.'):trans('step1.choose_your_delivery_date','Choose your delivery date.')}} <span class="pull-right" @click="closeDropdown()"><i class="fa fa-times"></i></span></p>
                                     </li>
                                    <li>

                                         <div class="text-center">
                                                <delivery-date-picker/>
                                                <p v-if="!form.delivery_date && delivery_data_submitted"
                                                   class="text-danger m-t-0 p-l-10">{{ form.is_pickup == 1 ?trans('step1.plz_select_delivery_date','Please Select Delivery Date.'):trans('step1.plz_select_fitting_date','Please Select Fitting Date.')}}</p>
                                         </div>
                                    </li>
                                    <li class="divider"></li>
                                    <li>
                                        <div class="row">
                                             <div class="col-sm-6 p-r-m-0">
                                                  <delivery-time-picker/>
                                                  <p v-if="!form.delivery_time && delivery_data_submitted" class="text-danger m-t-0 p-l-10">{{form.is_pickup == 1 ?trans('step1.plz_select_delivery_time','Please Select Delivery Time.'):trans('step1.plz_select_fitting_time','Please Select Fitting Time.')}}</p>
                                              </div>
                                            <div class="col-sm-6 p-l-m-0" v-if="form.delivery_date && form.delivery_time">
                                                <div class="form-group">
                                                    <label for="first-day-skiing">{{trans('step1.first_ski_date','First Ski Date')}}</label>
                                                    <input type="text" class="form-control" :value="form.first_day_skiing" id="first-day-skiing"  name="first-day-skiing" disabled v-if="form.delivery_time">
                                                    <input type="text" class="form-control" id="first-day-skiing2" name="first-day-skiing" disabled v-else>
                                                </div>
                                            </div>
                                        </div>

                                    </li>
                                    <li>
                                        <p class="f-11 p-l-10">{{form.is_pickup == 1 ?trans('step1.charged_fitting_description','Fitting after '+ cut_of_time +' will not be charged for a rental day',cut_of_time):trans('step1.charged_delivery_description','Deliveries after '+ cut_of_time +' will not be charged for a rental day',cut_of_time)}}</p>
                                    </li>
                                    <li>
                                        <div class="row m-t-10">
                                            <div class="col-xs-12">
                                                <button @click="saveDeliveryData" type="button" id="delivery-select" class="btn btn-primary select-button pull-right m-b-10">{{trans('step1.select_btn','Select')}}</button>
                                            </div>
                                        </div>
                                    </li>
                                    <li v-if="isLoading">
                                        <div class="overlay-loader">
                                            <i class="overlay-img-load"></i>
                                        </div>
                                    </li>
                              </ul>

                            </div>
                            <div class="horizontal-divider"></div>
                        </div>
                        <div class="col-md-3 font-13px">
                            <div class="dropdown">
                                <p class="text-center dropdown-toggle bs3-dropdown-toggle" id="return-drop-down" data-toggle="dropdown">
                                    <span class="pull-left">
                                        <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512"><!--! Font Awesome Free 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H64C28.7 64 0 92.7 0 128v16 48V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 144 128c0-35.3-28.7-64-64-64H344V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H152V24zM48 192H400V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192z"/></svg>
                                    </span>
                                    <span class="pull-right"><i class="fa fa-angle-down"></i></span>
                                    <span v-if="form.return_date" style="white-space: normal">{{ form.return_date }}</span>
                                         <span v-else style="white-space: normal">{{ trans('step1.return_date','Return Date') }}</span>
                                </p>
                                <ul v-if="form.resort_id && form.delivery_date && form.delivery_time" class="dropdown-menu bs3-drp-menu dropdown-return dropdown-calendar" :class="[dropdownUp? 'dropdown-menu-top' : '']">
                                    <li>
                                            <p class='m-b-15'>{{trans('step1.choose_your_return_date','Choose your return date.')}} <span class="pull-right" @click="closeDropdown()"><i class="fa fa-times"></i></span></p>
                                     </li>
                                    <li>
                                        <div class="text-center">
                                            <return-date-picker/>
                                            <p v-if="!form.return_date && return_data_submitted" class="text-danger m-t-0 p-l-10">{{trans('step1.plz_select_return_date','Please Select Your Return Date.')}}</p>
                                        </div>
                                    </li>
                                    <li class="divider"></li>
                                    <li>
                                        <p class="f-11">{{trans('step1.return_description','Please select your last day of skiing. We will pick up your equipment from your accommodations at the end of your final ski day.')}}</p>
                                    </li>
                                    <li>
                                        <div class="row">
                                            <div class="col-sm-7 col-md-8">
                                                <p class="text-center text-xs-left" style="margin-top: 7px" v-if="min_booking_days_text">{{min_booking_days_text}}</p>
                                                <p class="text-center text-xs-left" style="margin-top: 7px" v-else>{{trans('step1.min_booking_day',min_booking_days+1 +' - Day Minimum',min_booking_days+1)}}</p>
                                            </div>
                                            <div class="col-sm-5 col-md-4">
                                              <button @click="saveReturnData" type="button" id="return-select" class="btn btn-primary pull-right select-button">{{trans('step1.select_btn','Select')}}</button>
                                            </div>
                                        </div>

                                    </li>
                                    <li v-if="isLoading">
                                        <div class="overlay-loader">
                                            <i class="overlay-img-load"></i>
                                        </div>
                                    </li>
                              </ul>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <button type="button" class="btn btn-primary btn-block booking-button" v-if="step1_completed" @click="saveStep1">{{ trans('step1.book_now','Book Now') }}</button>
                            <button type="button" class="btn btn-primary btn-block booking-button" v-else>{{ trans('step1.book_now','Book Now') }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="short-delivery-detail" :class="route_name === 'Step2' ? 'visible-xs': 'hidden'">
            <short-delivery-detail :editing_allowed="true"/>
        </div>

        <!--    Modals-->
        <location-modal/>
        <delivery-date-modal/>
        <return-date-modal :from-wp="fromWp" :from-detail-bar="false"/>
        <div class="overlay-loader" v-if="isLoading">
            <i class="overlay-img-load"></i>
        </div>
    </div>

</template>
<script>
import {mapState, mapActions, mapGetters} from "vuex";
import ShortDeliveryDetail from "./ShortDeliveryDetail";
import DeliveryDateModal from "./modals/DeliveryDateModal";
import ReturnDateModal from "./modals/ReturnDateModal";
import LocationModal from "./modals/LocationModal";
import DeliveryDatePicker from "./DeliveryDatePicker";
import ReturnDatePicker from "./ReturnDatePicker";
import DeliveryTimePicker from "./DeliveryTimePicker";
import {EventBus} from "../EventBus";

export default {
    name: 'NewBookingFlayer',
    props: ['fromWp'],
    components: {
        DeliveryTimePicker,
        ReturnDatePicker,
        DeliveryDatePicker, LocationModal, ReturnDateModal, DeliveryDateModal, ShortDeliveryDetail},
    data(){
        return{
            location_data_submitted: false,
            delivery_data_submitted: false,
            return_data_submitted: false
        }
    },
    created(){
        // Watch the 'stores' property in the store.state
        this.$store.watch(
            (state) => state.stores,
            (newValue, oldValue) => {
                // Check if the 'stores' property has been updated
                if(!newValue.length > 0){
                    this.saveLocationData(true)
                }
            }
        );
    },
    watch: {
        getResortCode(newValue) {
            if (newValue === 'OSP' && this.form.resort_id) {
                if (this.form.is_pickup !== 1) {
                    this.form.is_pickup = 1;
                }
            }
        },
        stores: {
            handler(newStores) {
                if (this.getResortCode === 'OSP' && this.form.resort_id && newStores && newStores.length > 0) {
                    if (this.form.is_pickup !== 1) {
                        this.form.is_pickup = 1;
                    }
                    if (!this.form.store_id && newStores[0]) {
                        this.form.store_id = newStores[0].id;
                    }
                }
            },
            immediate: true
        },
        'form.resort_id'(newResortId) {
            if (newResortId && this.getResortCode === 'OSP') {
                this.$nextTick(() => {
                    if (this.form.is_pickup !== 1) {
                        this.form.is_pickup = 1;
                    }
                });
            }
        }
    },
    beforeDestroy() {
        document.removeEventListener('click', this.handleOutsideClick);
    },
    mounted() {

        let _this = this;
        console.log('new booking flayer');

        $('.bs3-dropdown-toggle').on('click', function() {
            var dropdown = $(this).siblings('.bs3-drp-menu');
            // $('.bs3-drp-menu').not(dropdown).removeClass('show');
            _this.closeDropdown()
            dropdown.toggleClass('show');

            let topPos = dropdown.hasClass('dropdown-menu-top') ? dropdown.offset().top :  dropdown.offset().top - 80;
            // Scroll the window to the top of the dropdown menu
            $('html, body').animate({
                scrollTop: topPos
            }, 500);


        });


        $('.bs3-drp-menu').on('click', function(e) {
            // Check if the clicked element is the close button
            if ($(e.target).hasClass('fa-times')) {
                // Handle close button action here
                // For example, close the dropdown or perform other actions
                console.log("Close button clicked");
                // Add your custom code here
            } else {
                e.stopPropagation();
            }
        });

        document.addEventListener('click', this.handleOutsideClick);

        EventBus.$on('resort-data-fetched', this.updateFocus)


        // this.$nextTick(function() {
        //
        //
        //     // $(document).on('shown.bs.dropdown', '.dropdown', function() {
        //     //     var dropdownMenu = $(this).find('.bs3-drp-menu');
        //     //     var dropdownOffset = dropdownMenu.offset().top - $(window).scrollTop();
        //     //     var marginTop = parseInt($(this).css('marginTop'));
        //     //     var spaceUp = dropdownOffset - marginTop;
        //     //
        //     //     if (spaceUp > 290) {
        //     //         dropdownMenu.addClass('dropdown-menu-top');
        //     //     } else {
        //     //         dropdownMenu.removeClass('dropdown-menu-top');
        //     //     }
        //     // });
        //     //
        //     // $(document).on('hidden.bs.dropdown', '.dropdown', function() {
        //     //     var dropdownMenu = $(this).find('.bs3-drp-menu');
        //     //     dropdownMenu.removeClass('dropdown-menu-top');
        //     // });
        //
        //
        //
        //
        //     // $(document).on('click', function(e) {
        //     //     $('.bs3-drp-menu').each(function() {
        //     //         var dropdownMenu = $(this);
        //     //         var isDropdownVisible = dropdownMenu.css('display') === 'block';
        //     //         if(isDropdownVisible){
        //     //             $(".bs3-dropdown-toggle").click();
        //     //         }
        //     //
        //     //     });
        //     //
        //     // });
        // });
        // Get query param from URL
        function getQueryParam(param) {
            const urlParams = new URLSearchParams(window.location.search);
            return urlParams.get(param);
        }

        // Set cookie for X hours
        function setCookie(name, value, hours) {
            const expires = new Date();
            expires.setTime(expires.getTime() + (hours * 60 * 60 * 1000));
            document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
        }

        // Get cookie by name
        function getCookie(name) {
            const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
            return match ? match[2] : null;
        }

        // Step 1: Set cookie from URL param
        const portalName = getQueryParam("portal_name");
        if (portalName) {
            setCookie("portal_name", portalName, 2); // 2-hour cookie
        }

        // Step 2: If cookie exists, make all links open in a new tab
        const cookiePortal = getCookie("portal_name");
        if (cookiePortal) {
            console.log(cookiePortal+' wasim');
            this.$nextTick(() => {
                document.querySelectorAll("a[href]").forEach(link => {
                    if (link.textContent.trim().toUpperCase() === "BOOK NOW") {
                        const newUrl = `https://www.blacktieskis.com/portal/?portal_name=${encodeURIComponent(cookiePortal)}`;
                        link.setAttribute("href", newUrl);
                        link.setAttribute("target", "_blank");
                    }
                });
            });
        }


    },
    computed: {
        step1_completed(){
            return (this.form.resort_id && this.form.delivery_date && this.form.first_day_skiing && this.form.delivery_time && this.form.return_date)
        },
        delivery_date_time(){
            let delivery_date = this.form.delivery_date ? this.form.delivery_date: '';
            let delivery_time = this.form.delivery_time ? this.form.delivery_time: '';
            let date_time = delivery_date+' '+delivery_time;
            if(date_time !== ' ' && date_time !== ' @ '){
                return delivery_date+' @ '+delivery_time
            }else{
                return null;
            }
        },
        route_name(){
            if(this.fromWp){
                if(this.step == 2){
                    return 'Step2';
                }else{
                    return 'Step1';
                }
            }else{
                return this.$route.name;
            }
        },

        resort_id(){
            return this.$store.state.form.resort_id;
        },
        is_pickup: {
            get(){
                return this.form.is_pickup;
            },
            set(value){
                this.form.is_pickup = value == 1 ? 1 : 0;
                this.form.store_id = null;
                this.form.delivery_date = null;
                this.form.delivery_time = null;
                this.form.return_date = null;
            }
        },
        store_id: {
            get(){
                return this.form.store_id;
            },
            set(value){
                this.form.store_id = value;
                this.form.delivery_date = null;
                this.form.delivery_time = null;
                this.form.return_date = null;
            }
        },
        dropdownUp(){
            let route_name = null;
            if(this.fromWp){
                if(this.step == 2){
                    route_name =  'Step2';
                }else{
                    route_name = 'Step1';
                }
            }else{
                route_name =  this.$route.name === 'Step_1' ? 'Step1' : this.$route.name;
            }

            if(window.location.href.indexOf('portal') > 0){
                return false
            }else{
                return route_name === 'Step1';
            }



        },

        ...mapState(['form','min_booking_days', 'min_booking_days_text', 'step','base_url', 'resorts', 'stores', 'isLoading', 'step', 'cut_of_time', 'portal']),
        ...mapGetters(['getResortName','getResortCode']),
    },
    methods: {
        trans(key, defaultValue,msg=null) {
            let translation = '';
            if(msg){
                translation = this.$t(key,{message:msg});
            }else{
                translation = this.$t(key);
            }
            return translation !== key ? translation : defaultValue;
        },
        saveStep1() {
            $('.how-it-work').hide();
            // this.$store.state.coupon = null;
            // this.$store.dispatch('applyGlobalCoupon');
            this.putDataInStorage()
            if(this.fromWp){
                if(location.origin === this.base_url){
                    location.href = this.base_url+'/reservations/step2'
                }else{
                    if(this.$i18n.locale=='fr'){
                        location.href = window.location.origin+'/fr/packages';
                    }else{
                        location.href = window.location.origin+'/packages';
                    }
                }
            }else{
                if(this.route_name === 'Step1' || this.route_name === 'Step_1' || this.route_name === 'Step1Portal'){
                    this.putDataInStorage()
                    this.$router.push({name : 'Step2'});
                }else{
                    //step 2 re-render
                    this.$store.dispatch('fetchPackages');
                }
            }

        },
        saveLocationData(from_watch = false) {
            this.location_data_submitted = true;
            if(from_watch){
                this.updateFocus();
            }
            if(this.form.resort_id){
                let rStore = {
                    resort_id: this.form.resort_id,
                    store_id: this.form.store_id
                };
                this.$store.dispatch('fillPortalData');
                if(!from_watch){
                    this.$store.dispatch('setResortStore', {data:rStore});
                }

                // $('.bs3-drp-menu').hide();
                if(this.$store.state.resort_change_clicked){
                    $("#delivery-drop-down").click();
                }
            }
            this.$forceUpdate();
        },
        saveDeliveryData() {
            this.delivery_data_submitted = true;

            this.$store.dispatch('clearDeliveryTimeIfWrong')


            if (this.form.delivery_date && this.form.delivery_time) {
                $("#return-drop-down").click();

            }else{

                this.focusNextButton('delivery-select');

                //focus on field
                // let ele = document.getElementById('delivery-modal-time-picker');
                // if(ele){
                //     this.cursorFocus(ele, 'start')
                // }
            }
        },

        saveReturnData() {
            let _this = this;
            this.return_data_submitted = true;

            if (_this.step1_completed) {
                _this.saveStep1();
                _this.closeDropdown();
            }
        },

        changeResort(value){
            let _this = this;
            _this.$store.state.resort_change_clicked = true;
            this.$store.dispatch('setResortID', {'resort_id':value});
        },
        updateFocus(){
            this.$nextTick(() => {
                setTimeout(() => {
                    const buttonWrapper = this.$refs.resortButtonWrapper;
                    if (buttonWrapper) {
                        const buttonEle = buttonWrapper.querySelector('#resort-next');
                        if (buttonEle) {
                            this.cursorFocus(buttonEle, 'nearest');
                        }
                    }
                }, 100);
            });
        },
        startOver(){
            this.$router.push(this.$store.getters.getStep1Route);
        },
        focusNextButton(id){
            let buttonEle = document.getElementById(id);
            if(buttonEle){
                this.cursorFocus(buttonEle, 'nearest')
            }
        },
        cursorFocus(elem, block='nearest') {
            setTimeout(() => {
                const dropdownMenu = elem.closest('.bs3-drp-menu');
                if (dropdownMenu) {
                    dropdownMenu.scrollTop = dropdownMenu.scrollHeight;
                }
                elem.focus();
                elem.scrollIntoView({behavior: "smooth", block: block});
            }, 100);


        },
        handleOutsideClick(event) {
            console.log('cliced')
            if (!this.$el.contains(event.target)) {
                // $('.bs3-drp-menu').hide();

                let dropdowns_return = document.querySelectorAll('.dropdown-return.show');
                dropdowns_return.forEach(function(dropdown) {
                    dropdown.classList.remove('show');
                });


                let dropdowns_delivery = document.querySelectorAll('.dropdown-delivery.show');
                dropdowns_delivery.forEach(function(dropdown) {
                    dropdown.classList.remove('show');
                });


                let dropdowns = document.querySelectorAll('.dropdown-location.show');
                dropdowns.forEach(function(dropdown) {
                    dropdown.classList.remove('show');
                });
            }
        },
        closeDropdown(){
            $('body').click();
        },
        ...mapActions(['updateStep', 'putDataInStorage']),
    }
}
</script>

